import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { DynamicPricing } from './components/DynamicPricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from './hooks/useLanguage';

export default function LandingPage() {
  const { t, language, setLanguage } = useLanguage();

  return (
    <div className="bg-zinc-950 min-h-screen text-zinc-50 selection:bg-emerald-500/30">
      <Navbar t={t} currentLang={language} setLanguage={setLanguage} />
      <main>
        <Hero t={t} />
        <Features t={t} />
        
        {/* Dynamic Pricing - fetched from database */}
        <DynamicPricing t={t} lang={language} />
        
        <FAQ t={t} />
        
        {/* Final CTA Section */}
        <section className="relative isolate mt-32 px-6 py-32 sm:mt-56 sm:py-40 lg:px-8">
          <div className="absolute inset-0 -z-10 overflow-hidden transform-gpu blur-3xl" aria-hidden="true">
            <div className="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#10b981] to-[#059669] opacity-20" style={{clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'}}></div>
          </div>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              {t.final_cta.title}<br />
              {t.final_cta.subtitle}
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-zinc-300">
              {t.final_cta.desc}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/register"
                className="group relative flex items-center gap-2 rounded-full bg-emerald-500 px-8 py-4 text-base font-semibold text-white transition-all hover:bg-emerald-400 hover:shadow-[0_0_30px_-5px_rgba(16,185,129,0.4)]"
              >
                {t.final_cta.btn}
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer t={t} />
    </div>
  );
}
